import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from 'vue'
import { useI18n } from 'vue-i18n-composable'
import DashboardActionItemComponent from '@/components/widgets/DashboardWidgets/actions/DashboardActionItem.vue'
import SpinnerLayerComponent from '@/components/Spinner/SpinnerLayerComponent.vue'
import { Icons } from '@/icons/icons'
import { URLS } from '@/router/routes/urlRoutes'
import useActionsWidget from '@/components/widgets/DashboardWidgets/actions/composable/useActionsWidget'
import { ListStatus } from '@/store/modules/dashboardWidgets/dashboardWidgetsTypes'

// TRANSLATIONS

export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardActionsWidget',
  setup(__props) {

const { t } = useI18n()

const texts = {
  newActions: t('components.widgets.actions.new_actions'),
  noData: t('components.widgets.actions.no_data'),
  loadError: t('components.widgets.actions.load_error'),
  title: t('components.widgets.actions.title')
}

// DATA
const noDataIcon = Icons.ARCHIVE_EMPTY
const errorIcon = Icons.CLOSE_ROUND
const path = 'components.widgets.actions.link_text'
const actionsListURL = `${URLS.ACTIONS}/${URLS.ACTION_ALL}`

// COMPOSABLE
const { status, widgetList, loadWidgets } = useActionsWidget()

// HOOKS
onMounted(() => loadWidgets())

return { __sfc: true,t, texts, noDataIcon, errorIcon, path, actionsListURL, status, widgetList, loadWidgets, DashboardActionItemComponent, SpinnerLayerComponent, ListStatus }
}

})